import React from 'react';
import { Route } from '@/navigation/Route';
import { GatewayPriorityScreen } from './screens';

export const GATEWAY_PRYORITY_ROUTES = {
  itself: '/dashboard/gateway-priority',
};

export const GatewayPriorityNavigation = (): JSX.Element => (
  <Route
    exact
    path={GATEWAY_PRYORITY_ROUTES.itself}
    component={GatewayPriorityScreen}
    isPrivateRoute
  />
);
